export default "__VITE_ASSET__DswEHL9u__"